import React, { Component, Fragment } from "react";
import { FormattedMessage } from "react-intl";

import { generatePath } from "../../../../../../../paths";
import Draggable from "../../../../../../Draggable";

import { Wrapper, Container, Window, Point, Button } from "../shared-style";
import { getImageDimensions, IGetImageDimensionsThis } from "../methods";

import messages from "./messages";
import { Remove } from "./styles";
import { IProps, IState } from "./interfaces";

class Systems extends Component<IProps, IState> {
    system?: HTMLDivElement;
    img?: HTMLImageElement;
    constructor(props: IProps) {
        super(props);
        this.state = {
            width: 0,
            height: 0,
            scale: 1,
            zoom: 1,
        };

        const { task, taskIndex, editTask } = props;
        const { data } = task;
        if (!data.systems) {
            let systems = {
                starts: [10],
                height: 80,
            };
            editTask({ taskIndex, changingProp: "systems", val: systems });
            setTimeout(this.save, 100);
        }
    }
    componentDidMount() {
        setTimeout(this.resize);
        window.addEventListener("resize", this.resize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }
    resize = () => {
        let scale = this.system!.parentElement!.parentElement!.getBoundingClientRect().width / 1280;
        this.setState({ scale });
    };

    setPoint = (index: number, settingHeight: boolean, x: number, y: number) => {
        const { task, taskIndex, editTask } = this.props;
        let systems = { ...task.data.systems! };
        const { height, zoom } = this.state;
        x *= zoom;
        y *= zoom;
        if (settingHeight) {
            systems.height = y - systems.starts[index];
            systems.height = Math.max(systems.height, 30);
            let maxStart = Math.max.apply(null, systems.starts);
            if (maxStart + systems.height > height * zoom) {
                systems.height = height * zoom - maxStart;
            }
            systems.starts.forEach((start, index) => {
                if (index === systems.starts.length - 1) return;
                if (start + systems.height > systems.starts[index + 1]) {
                    systems.height = systems.starts[index + 1] - start;
                }
            });
            systems.height = Math.ceil(systems.height);
        } else {
            systems.starts[index] = y - (index !== 0 ? systems.height / 2 : 0);
            if (systems.starts[index] + systems.height > height * zoom) {
                systems.starts[index] = height * zoom - systems.height;
            }
            if (systems.starts[index] < 0) systems.starts[index] = 0;
            if (index > 0 && systems.starts[index] < systems.starts[index - 1] + systems.height) {
                systems.starts[index] = systems.starts[index - 1] + systems.height;
            }
            if (
                index + 1 < systems.starts.length &&
                systems.starts[index] + systems.height > systems.starts[index + 1]
            ) {
                systems.starts[index] = systems.starts[index + 1] - systems.height;
            }
            systems.starts[index] = Math.ceil(systems.starts[index]);
        }
        editTask({ taskIndex, changingProp: "systems", val: systems });
    };

    addSystem = () => {
        const { task, taskIndex, editTask } = this.props;
        let systems = { ...task.data.systems! };
        systems.starts.push(systems.starts[systems.starts.length - 1] + systems.height + 10);
        editTask({ taskIndex, changingProp: "systems", val: systems });
        this.save(true);
    };

    removeSystem = (index: number) => {
        const { task, taskIndex, editTask } = this.props;
        let systems = { ...task.data.systems! };
        systems.starts.splice(index, 1);
        editTask({ taskIndex, changingProp: "systems", val: systems });
        this.save(true);
    };

    dragStop = () => {
        this.save();
    };

    save = (modify = false) => {
        const { plan, post, taskIndex, task } = this.props;
        const {
            data,
            data: { systems },
        } = task;
        if (modify) {
            delete data.bars;
            delete data.nonBars;
            delete data.sameTypes;
            delete data.scale;
            delete data.scorePosition;
            delete data.drags;
            this.props.setLatestStage();
        }
        post("score-editor-systems", {
            planId: plan._id,
            index: taskIndex,
            systems,
            modify,
        });
    };

    render() {
        const { task: { data: { score, systems } } } = this.props;
        const { width, height, scale, zoom } = this.state;
        return (
            <Container ref={sy => { this.system = sy!; }}>
                <Wrapper>
                    <img
                        src={generatePath(score!)}
                        ref={img => { this.img = img!; }}
                        onLoad={() => getImageDimensions.call(this as unknown as IGetImageDimensionsThis)}
                        width={width}
                        height={height}
                        alt="score"
                    />
                    {!!width && !!height && (
                        <>
                            {systems!.starts.map((startY, index) => {
                                return (
                                    <Fragment key={index}>
                                        <Draggable
                                            position={{
                                                x: width / 2,
                                                y: index === 0 ? startY / zoom : (startY + systems!.height / 2) / zoom,
                                            }}
                                            scale={scale}
                                            onDrag={(x, y) => this.setPoint(index, false, x, y)}
                                            onStop={this.dragStop}
                                        >
                                            <Point style={{ cursor: "move" }} />
                                        </Draggable>
                                        {index === 0 && (
                                            <Draggable
                                                position={{
                                                    x: width / 2,
                                                    y: (startY + systems!.height) / zoom,
                                                }}
                                                scale={scale}
                                                onDrag={(x, y) => this.setPoint(index, true, x, y)}
                                                onStop={this.dragStop}
                                            >
                                                <Point style={{ cursor: "ns-resize" }} />
                                            </Draggable>
                                        )}
                                        <Window
                                            style={{
                                                top: startY / zoom,
                                                height: systems!.height / zoom,
                                                left: 0,
                                                width,
                                            }}
                                        />
                                        {index > 0 && (
                                            <Remove
                                                style={{
                                                    top: startY / zoom,
                                                    left: width - 46,
                                                }}
                                                onClick={() => {
                                                    this.removeSystem(index);
                                                }}
                                            >
                                                X
                                            </Remove>
                                        )}
                                    </Fragment>
                                );
                            })}
                        </>
                    )}
                </Wrapper>
                <Button>
                    <button className={"button"} onClick={this.addSystem}>
                        <FormattedMessage {...messages.newSystem} />
                    </button>
                </Button>
            </Container>
        );
    }
}

export default Systems;
